var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"item",attrs:{"to":_vm.url}},[(!!this.icon)?_c('i'):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }